import { createAction } from 'redux-actions'
import { tabeebHubName } from './constants'

export const createTabeebHubAction = (name) => createAction(`${tabeebHubName.toUpperCase()}_${name}`)
export const createHealthDeviceHubAction = (name) => createAction(`${tabeebHubName.toUpperCase()}_${name}`)
